import React, { useEffect, useState } from 'react'
import IntegrationTopbar from './Topbar'
import GoogleSignIn from '../../../authentication/component/GoogleSignIn'
import AuthForm from './AuthForm'
import { useAppServices } from '../../../../hook/services'
import { useNavigate } from 'react-router-dom'
import { useUserInfo } from '../../../../context/user'

const IntegrationSignup = () => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const queryString = window.location.search;
    const account_id = new URLSearchParams(queryString).get("id");
    const domain = urlObject.hostname;
    const service = useAppServices();
    const navigate = useNavigate();
    const [whitelabel, setwhitelabel] = useState("");
    const updateUser = useUserInfo()[1];
    const saveActiveLocation = useUserInfo()[5];
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [formInputs, setFormInputs] = useState({
        email: "",
        password: "",
        type: "email",
        userName: "",
    });


    const getting_whitelable_domain = async () => {
        const payload = {
            domain: domain
        };
        const { response, error } = await service.agency.getwhitelabel({
            payload: payload,
        });
        if (response) {
            setwhitelabel(response.data);
        }
    };

    useEffect(() => {
        getting_whitelable_domain();
    }, []);

    const handleSubmit = async (e) => {
        // If called as a DOM event, prevent default. If called with an object (e.g. GoogleSignIn passes user data),
        // that object won't have preventDefault and we should not call it.
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        setLoading(true);
        const payload = {
            ...(e && e.email ? e : formInputs),
            user_type: "integration",
            ...(account_id ? { account_id } : {}),
            agency_id: domain?.includes("localhost")
                ? "6739f1be347a7f5974735cec"
                : whitelabel?._id || "6739f1be347a7f5974735cec",
        }

        const { response, error } = await service.auth.integrationAppSignup({
            payload: payload
        });

        if (response?.success) {
            updateUser(response?.data);
            saveActiveLocation(response?.activeLocation || []);
            setLoading(false);
            if (payload.type === "google") {
                navigate("/integration-app/");
            } else {
                window.location.href='/auth/verify-email'
            }
        }
        if (error?.message) {
            setError(error?.message);
            setLoading(false);
        }
    }


    return (
        <div className='flex flex-col items-center justify-center h-screen'>
            <IntegrationTopbar account_id={account_id} />
            <div className='h-full flex flex-col items-center justify-center'>
                <h1 className="font-semibold text-2xl max-w-[450px] mt-[58px] text-center">Create your account to get your AI Agents connected</h1>
                <GoogleSignIn
                    buttonText={"Sign up with Google"}
                    enabled
                    onSuccess={handleSubmit}
                    onUnavailable={setError}
                />
                <p className="relative border-b !border-[#D9D9D9] w-full my-6">
                    <span className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 px-4 text-[#B3B3B3] py-2 bg-white">
                        OR
                    </span>
                </p>
                <p className="mb-8">Enter your email and password below to create your account</p>

                <input
                    type="text"
                    required
                    placeholder="Your Name"
                    className='mb-3'
                    name="userName"
                    value={formInputs.userName}
                    onChange={(e) => setFormInputs({ ...formInputs, [e.target.name]: e.target.value })}
                />
                <AuthForm
                    formInputs={formInputs}
                    onChange={(e) => { setFormInputs({ ...formInputs, [e.target.name]: e.target.value }) }}
                    handleSubmit={handleSubmit}
                    loader={loading}
                    error={error}
                />
            </div>
        </div >
    )
}

export default IntegrationSignup
